"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EnterOTP = void 0;
const doNothing_1 = __importDefault(require("@opsbase/lib-general/utils/doNothing"));
const lib_i18n_1 = __importDefault(require("@opsbase/lib-i18n"));
const lib_pages_1 = __importDefault(require("@opsbase/lib-pages"));
const lib_palette_1 = __importDefault(require("@opsbase/lib-palette"));
const react_useauth_1 = __importDefault(require("@opsbase/react-useauth"));
const useAppState_1 = __importDefault(require("@opsbase/web-app-state/useAppState"));
const Vertical_1 = __importDefault(require("@opsbase/web-layout/Vertical"));
const useNav_1 = __importDefault(require("@opsbase/web-nav/useNav"));
const useParams_1 = __importDefault(require("@opsbase/web-nav/useParams"));
const useNotificationActions_1 = __importDefault(require("@opsbase/web-notification/useNotificationActions"));
const Button_1 = __importDefault(require("@opsbase/web-ui/Button"));
const Spinner_1 = __importDefault(require("@opsbase/web-ui/Spinner"));
const Text_1 = __importDefault(require("@opsbase/web-ui/Text"));
const react_1 = __importStar(require("react"));
const EnterCode_1 = __importDefault(require("./EnterCode"));
function EnterOTP() {
    const [code, setCode] = (0, react_1.useState)('');
    const submitRef = (0, react_1.useRef)();
    const [busy, setBusy] = (0, react_1.useState)(true);
    const [id, setId] = (0, react_1.useState)();
    const { goTo, goBack } = (0, useNav_1.default)();
    const { identifier } = (0, useParams_1.default)();
    const { raiseError } = (0, useNotificationActions_1.default)();
    const { api } = (0, react_useauth_1.default)();
    const { app } = (0, useAppState_1.default)();
    const isValid = code.length === 4;
    const triggerPassKey = (0, react_1.useMemo)(() => () => __awaiter(this, void 0, void 0, function* () {
        const p = yield api.passKey(app, identifier).catch(() => {
            raiseError(lib_i18n_1.default.t('error-auth-signup'));
            goTo(lib_pages_1.default.AUTH_SIGNIN);
        });
        setId(p);
        setBusy(false);
    }), [api, app, goTo, identifier, raiseError]);
    (0, react_1.useEffect)(() => {
        triggerPassKey().catch(doNothing_1.default);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const handleSubmit = (0, react_1.useCallback)(() => {
        setBusy(true);
        api.otpSignIn(app, id, code)
            .catch(raiseError)
            .finally(() => setBusy(false));
    }, [api, app, code, id, raiseError]);
    if (!identifier)
        goTo(lib_pages_1.default.AUTH_SIGNIN);
    return (react_1.default.createElement(Spinner_1.default, { busy: busy },
        react_1.default.createElement(Vertical_1.default, { gutter: true, centered: true },
            react_1.default.createElement(Text_1.default, null, lib_i18n_1.default.t('enter_pass_key')),
            react_1.default.createElement(EnterCode_1.default, { submitRef: submitRef.current, onChange: setCode }),
            react_1.default.createElement(Button_1.default, { ref: submitRef, color: lib_palette_1.default.secondary, disabled: !isValid, fullWidth: true, loading: busy, onClick: handleSubmit, label: lib_i18n_1.default.t('sign-in') }),
            react_1.default.createElement(Text_1.default, null, "or"),
            react_1.default.createElement(Button_1.default, { color: lib_palette_1.default.positive, fullWidth: true, disabled: busy, onClick: goBack, label: lib_i18n_1.default.t('back') }))));
}
exports.EnterOTP = EnterOTP;
exports.default = EnterOTP;
